import React from 'react'
import { useUser } from '../../hooks/useUser'
import { routesDef } from '../../config/routes'
import { ShowIf } from '@ztechapps/webui.util'
import { NotificationWidget } from '../../components/Header/header-widget'

export const MessageWidget = () => {
  const { loggedIn } = useUser()

  return (
    <ShowIf condition={loggedIn}>
      <NotificationWidget count={0} icon="comment-dots" href={routesDef.AccountMessages.path} />
    </ShowIf>
  )
}
